import Crown from './Crown';

export default Crown;
